import { useEffect } from "react";
import Lenis from "lenis";

// Smooth scroll + âncoras (#secao) com offset da navbar.
export const useLenis = () => {
  useEffect(() => {
    try {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
      let raf;
      const loop = (time) => {
        lenis.raf(time);
        raf = requestAnimationFrame(loop);
      };
      raf = requestAnimationFrame(loop);
      const onAnchor = (e) => {
        const a = e.target.closest('a[href^="#"]');
        if (!a) return;
        const el = document.querySelector(a.getAttribute("href"));
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -72 });
        }
      };
      document.addEventListener("click", onAnchor);
      return () => {
        cancelAnimationFrame(raf);
        document.removeEventListener("click", onAnchor);
        lenis.destroy();
      };
    } catch (err) {
      console.error("Lenis error:", err);
    }
  }, []);
};
